import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Button, Tooltip } from 'antd';
import { ADMSRDF } from '../../const/C';
import Label from '../widgets/Label';
import Lang from '../widgets/Lang';
import { AdmsAsset, RdfTriplet } from '../../redux';
//import EditLiteralForm from '../widgets/EditLiteral';
import TranslateLiteralForm from '../widgets/TranslateLiteral';
import { getValues } from '../../virtuoso/helper'
import SelectIndividualForm from '../../components/adms/SelectIndividual';

/** Отображение списка значений для карточки ADMS
 * Формируется таблица, содержащая столбец с названием поля и столбец со значением поля
 * Для отображения поля используются специальные компоненты. Виды компонент описаны в widgets.
 * Получает список 
 */
const serviceFields = [];
const sortedStartPart = ["http://www.w3.org/1999/02/22-rdf-syntax-ns#about", "http://purl.org/dc/terms/language"]
const sortedFinishPart = ["http://www.w3.org/2002/07/owl#versionInfo", "http://csi.semanticpro.org/2016/ns#prefix"]
const exclude = ["http://www.w3.org/ns/dcat#theme", "http://www.w3.org/1999/02/22-rdf-syntax-ns#type", 
  "http://hbz.ru/ontologies/emd/wiki", "http://www.w3.org/ns/dcat#distribution", "http://www.w3.org/ns/adms#status",
  "http://open-services.net/ns/cm#status"];


const showSelectIndividual = (formRef=f=>f, IRI, predicat, existing, factory, lang, onFinishOperation=f=>f, onCancelOperation=f=>f) => {
	//console.log("syncPercent", syncPercent);
	return <Modal style={{minWidth: "80%"}} visible={true} title="Выбор элемена для связи" cancelText="Отмена" okText="Ок" 
		onCancel={onCancelOperation} onOk={onFinishOperation}>
        <SelectIndividualForm wrappedComponentRef={formRef} IRI={IRI} existing={existing} 
          factory={factory} predicat={predicat} lang={lang}/>
	  </Modal>
}


//Фильтрует полученные свойства для отображения. Исключает служебные свойства, свойства с пустыми значениями
//predicates содержит все предикаты, имеющие значения
const filterForShow = (factory, predicates, values) => {
    //console.log("const filterForShow = (factory, predicates, values)", predicates, values);
    //Исключаем служебные элементы. Пока их нет!
    const first = predicates.filter(key => !serviceFields.includes(key)); 
    //Исключаем свойства, которые не должны показываться
    const properties = first.filter(key => !exclude.includes(key));
    //Формируем последовательность свойств для отображения
    //console.log(properties)
    return properties.sort ((a, b) => {
            //console.log("0", a, b);
            //Начало списка свойств
            let indexA = sortedStartPart.indexOf(a);
            let indexB = sortedStartPart.indexOf(b);
            //console.log("1", indexA, indexB);
            if (indexA>-1){
                if (indexB>-1) return indexA-indexB;
                return -1;
            };
            if (indexB>-1) return 1;
            //конец списка свойств
            indexA = sortedFinishPart.indexOf(a);
            indexB = sortedFinishPart.indexOf(b);
            //console.log("2", indexA, indexB);
            if (indexA>-1){
                if (indexB < 0) return 1;
                return indexA-indexB;
            };
            if (indexB>-1) return 1;
            return 0;
        });
}
//Отображение Меток на английском языке
const EnLabel = ({props}) =>{
    return <span>&nbsp;(<Label {...props} lang="en"/>)</span>
}
class AssetLabel extends React.Component {

  render() {
    const {lang} = this.props;
        //<div className="csi_field_div">!!!</div>
        //  <Label {...this.props} />{(lang!="en")&& <EnLabel props={this.props}/>}
    return(
      <div className="csi_field_div">
        <Tooltip placement="left" title={this.props.iri}>
          <Label {...this.props} />
        </Tooltip>
      </div>
    )
  }
}
class AssetLabel2 extends React.Component {
  render() {
    const {graph, iri, lang} = this.props;
    return(
      <div className="csi_field_div">{iri}</div>
    )
  }
}


/** Для отображения значения поля. Для отображения необходимо указать:
 * 1. Предикат, содержащий данные
 * 2. Массив данных из которых их брать
 * 3. Язык
 * 4. Фабрика, которая возвращает компоненту для создания
 */
const FieldViewProxy = ({predicat, values, lang, factory, action}) =>{
    //console.log("FieldViewProxy", predicat, lang, factory, factory.ui);
    const Component = factory.ui.getUIComponent(predicat);
    //console.log("FieldViewProxy2", Component);
    return (
        <div className="csi_value_div" property={predicat}>
          <Component lang={lang} uri={predicat} values={values} factory={factory} action={action}/>
        </div>
    )
}

/** Для отображение редактирование поля. Редактирование обеспечивается созданием
 * формы ввода.
 */
const FieldEditProxy = ({predicat, values, lang, factory, vselected, action=f=>f}) =>{
    //console.log("AssetData.js FieldEditProxy", predicat, values, lang, factory, vselected)
    const isOperation = (vselected && vselected.predicat==predicat);
    const Component = (isOperation)? factory.ui.getUIComponent(predicat, "edit"): factory.ui.getUIComponent(predicat);
    const l = factory.provider.isObjectProperty(predicat);
    return (
        <div className="csi_value_div">
            { !isOperation && (<SelectOperation predicat={predicat} e={true} d={true} l={l} action={action}/>)}
            { !isOperation && (<br />)}
            <Component lang={lang} uri={predicat} values={values} factory={factory}/>
        </div>
    )
}
/** Для отобржаения данных в режиме перевода */
const FieldTranslateProxy = ({predicat, values, lang, factory, vselected, action=f=>f}) =>{
  const isOperation = (vselected && vselected.predicat==predicat);
  const Component = factory.ui.getUIComponent(predicat);
  return (
    <div className="csi_value_div"> 
            { !isOperation && (<SelectOperation predicat={predicat} t={true} action={action} factory={factory}/>)}
            { !isOperation && (<br />)}
            { isOperation && <span  style={{marginRight: "16px"}}><Lang lang={lang} editable={false} /></span>}
            <Component lang={lang} uri={predicat} values={values} factory={factory} />
            { isOperation && (<br />)}
            { isOperation && (<TranslateLiteralForm factory={factory}/>)}
    </div>
  )
}
const { confirm } = Modal;
/** Форимрует выподающий список для операций */
const ButtonGroup = Button.Group;
const SelectOperation = ({predicat, e, d, t, l, action}) =>{
    return  (
        <ButtonGroup style={{verticalAlign: "0em"}}>
            {e && <Button type="dashed" size="small" icon="edit" onClick={(e)=> action(e, "edit", predicat)}></Button>}
            {d && <Button type="dashed" size="small" icon="delete"  onClick={(e)=> action(e, "delete", predicat)}></Button>}
            {t && <Button type="dashed" size="small" icon="line-height" onClick={(e)=> action(e, "translate", predicat)}></Button>}
            {l && <Button type="dashed" size="small" icon="link" onClick={(e)=> action(e, "link", predicat)}></Button>}
        </ButtonGroup>
    )
}
/** Базовая компонента отображения свойств.
 * Обработка событий при модификации содрежимого происходит в родительской компоненте. 
 * Для этого из родительского компонента передаётся handlers
 */
class AssetData extends React.Component {

  state = {
      selected: undefined,    //Свойство (predicat), которое редактируется, удаляется или для него осуществляется перерво
      operation: "view",      //Текущая операция. Может быть view, edit, translate, delete
      selectedIndividual: false, //Флаг, для отображения далога выбора и добавления новой связи в ObjectProperty
    }

  modalFormRef = formRef => {
    this.formRef = formRef;
  }

    /** Обработчик действий над элементом в форме  */
    onAction (e, type, predicat) {
        e.preventDefault();
        console.log("AssetData.js onAction", e, type, predicat); console.log(this); 
        //Режим редактирования, удаления или перевода
        if ((type=="edit")||(type=="translate")){
            const value = getValues(predicat, this.props.lang, this.props.values);
            this.props.dispatch(RdfTriplet.SELECTED(type, this.props.iri, predicat, value));
            return;
        }
        if (type=="delete"){
            const { iri, dispatch } = this.props;
            const value = getValues(predicat, this.props.lang, this.props.values);
            confirm({
                title: 'Удалить выбранное свойство?',
                content: value,
                okText: 'Да',
                okType: 'danger',
                cancelText: 'Нет',
                onOk() {
                  console.log('OK', iri, predicat);
                  dispatch(AdmsAsset.removeProperty(iri, predicat));
                },
                onCancel() {
                    //this.setState({selected: predicat, operation: "view"})
                },
              });
            return;
        }
        if (type=="cancel"){
            this.setState({selected: predicat, operation: "view"})
            return;
        }
        if (type=="detail"){
            const {handlers} = this.props;
            if (handlers) handlers(e, predicat, type);
        }
              //Добавление новой ссылки в собъектное совойства
        if (type=="link"){
          this.setState({selectedIndividual: true, objectProperty: predicat});
      }
  }

  cancelOperation(){
    this.setState({selectedIndividual: false});
  }

  /** Вызывается при добавлении новой связи в объектное свойство. Данные см. SelectIndividual.js */
  submitSelectIndividual(operation) {
    this.setState({selectedIndividual: false});
    const { form } = this.formRef.props;
    console.log('AssetCard.js submitSelectIndividual ', this, operation, form);
    form.validateFields((err, values) => {
      if (err) return; console.log("Received values of form: ", values);
      this.props.dispatch(AdmsAsset.updateObjectProperty(this.props.iri, this.state.objectProperty, values.IRI, values.IRI));

      // this.props.onAddProperty(AdmsAsset, this.props.IRI, predicat, this.props.lang)
      //     .then (response =>{ 
      //       //const time = showMessageSuccess(store, "Добавление записи завершено успешно.");
      //       message.success("Добавление свойсва завершено успешно.");
      //       this.setState({detail: undefined, adding: false, selectedIndividual:false, operation: "view"});
      //     })
      //     .catch(e => {  message.error(`Ошибка при добавления свойства в каталог. ${e}`); });                  
    });
  };

  render(){
    //console.log(this); 
    const {predicates, values, lang, factory, operation, vselected, iri, handlers} = this.props;
    const {selectedIndividual, objectProperty} = this.state;
    const properties =  filterForShow(factory, predicates, values)
    const FieldProxy = (operation=="edit")? FieldEditProxy: (operation=="translate")? FieldTranslateProxy: FieldViewProxy;
    return (
      <span>
        <Row className="assetCardTable_tr"> 
          <Col span={10} className="assetCardTable_td"><div className="csi_field_div">IRI</div></Col>
          <Col span={14} className="assetCardTable_td"><div className="csi_value_div">{iri}</div></Col>
        </Row>
        {properties.map((prop, i) => 
          <Row key={i} className="assetCardTable_tr"> 
            <Col span={10} className="assetCardTable_td">
              <AssetLabel iri={prop} />
            </Col>
            <Col span={14} className="assetCardTable_td" style={{display: "block"}}>
              <FieldProxy 
                factory={factory} lang={lang} predicat={prop} values={values} vselected={vselected}
                {...this.state} 
                action={(e, type, predicat)=> this.onAction(e, type, predicat)}/>
            </Col>
          </Row>
        )}
        {selectedIndividual  && showSelectIndividual(this.modalFormRef, iri, objectProperty, values, factory, lang, ()=>this.submitSelectIndividual(operation), ()=>this.cancelOperation())}
      </span>
    )
  }
}

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vasset, vset, vselected} = state;
    const {lang} = props;
    return {
        lang: (lang)?lang: vset.lang,
        ...vasset,
        vselected,
        factory: props.factory
    };
}
export default connect(mapStateToProps)(AssetData);